<template>
  <v-row>
    <v-col v-if="computedProdutos.length" cols="12" class="pb-0">
      <v-list
        class="pa-0"
        three-line
        :style="produtosContainer"
      >
        <v-list-item
          v-for="(produto, i) in computedProdutos"
          :key="i"
          class="pt-0"
        >
          <v-list-item-content class="pb-0">
            <v-col cols="10" md="4" class="pa-0">
              <v-list-item-title class="body-2 font-weight-bold">
                <v-icon small>mdi-clipboard-text</v-icon>
                {{ produto.descricao }}
              </v-list-item-title>
            </v-col>
            <v-col cols="12" md="4" offset-md="0" class="pa-0">
              <v-list-item-title class="caption">
                <v-icon small>mdi-package-variant-closed</v-icon>
                {{ produto.qt_estoque }} x {{ produto.unidade }}
              </v-list-item-title>
            </v-col>
            <v-col cols="10" md="4" class="pa-0">
              <v-list-item-title class="body-2">
                {{ produto.preco_bruto | price }}
              </v-list-item-title>
            </v-col>
            <v-divider
              :key="i"
              class="mt-2"
            ></v-divider>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <div class="text-center mt-1" id="listProdutosPagination">
        <v-pagination
          v-model="page"
          :length="totalPages"
          circle
        ></v-pagination>
      </div>
    </v-col>
    <v-col v-else cols="12">
      <p class="text-center font-weight-bold white py-3">Nenhum registro encontrado</p>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { convertStringToCompare } from '@/helpers';

export default {
  name: 'ListProdutos',
  props: {
    filters: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    page: 1,
  }),
  computed: {
    ...mapGetters(['produtos']),
    produtosContainer() {
      const offset = 80;
      const windowHeight = window.outerHeight;
      const paginationDiv = document.getElementById('listProdutosPagination');
      const paginationHeight = paginationDiv ? paginationDiv.clientHeight : 44;
      const produtosContainerHeight = windowHeight - paginationHeight - offset;
      return {
        height: produtosContainerHeight.toString() + 'px',
        overflow: 'auto'
      }
    },
    computedProdutos() {
      const start = (this.page - 1) * 10;
      const end = start + 10;
      let searchTerm = this.filters.search || '';
      searchTerm = convertStringToCompare(searchTerm);
      return this.produtos
        .filter(produto =>
          convertStringToCompare(produto.id_produto).includes(searchTerm || '') ||
          convertStringToCompare(produto.numero).includes(searchTerm || '') ||
          convertStringToCompare(produto.descricao).includes(searchTerm || '')
        )
        .slice(start, end)
        .sort((a, b) => a[this.filters.order] > b[this.filters.order] ? 1 : -1);
    },
    totalPages() {
      const total = this.produtos.length / 10;
      return total !== Infinity ? Math.ceil(total) : 0;
    }
  }
}
</script>

<style>

</style>